import React from "react";
import { formatPriceQuote } from "../presentation/money";

const PriceBlock = ({
  quote,
  settings = {},
  language = "english",
  showPriceOnSelection = false,
  color,
  inverted = false,
}) => {
  if (!quote) return null;
  if (showPriceOnSelection && quote.base <= 0) {
    return (
      <span style={{ color, fontWeight: 700 }}>
        {language === "arabic" ? "السعر عند الاختيار" : "Price on selection"}
      </span>
    );
  }

  const formatted = formatPriceQuote(quote, { settings, language });
  return (
    <span
      style={{
        alignItems: "baseline",
        color,
        display: "inline-flex",
        flexWrap: "wrap",
        gap: 6,
      }}
      dir={language === "arabic" ? "rtl" : "ltr"}
    >
      {quote.isDiscounted && (
        <span
          aria-label={language === "arabic" ? "السعر الأصلي" : "Original price"}
          style={{
            color: inverted ? "rgba(255,255,255,0.82)" : "#777",
            fontSize: 12,
            textDecoration: "line-through",
          }}
        >
          {formatted.originalText}
        </span>
      )}
      <span style={{ fontWeight: 700 }}>{formatted.currentText}</span>
      {(quote.includesPreselectedOptions || quote.preselectedOptions > 0) && (
        <span
          style={{
            color: inverted ? "rgba(255,255,255,0.82)" : "#777",
            fontSize: 11,
          }}
        >
          {language === "arabic" ? "يشمل الاختيارات" : "includes defaults"}
        </span>
      )}
    </span>
  );
};

export default PriceBlock;
